/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Form_Phone_LabelInputs */

const en_business_form_phone_label = /** @type {(inputs: Business_Form_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone Number (optional)`)
};

const es_business_form_phone_label = /** @type {(inputs: Business_Form_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de teléfono (opcional)`)
};

/**
* | output |
* | --- |
* | "Phone Number (optional)" |
*
* @param {Business_Form_Phone_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_form_phone_label = /** @type {((inputs?: Business_Form_Phone_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Form_Phone_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_form_phone_label(inputs)
	return en_business_form_phone_label(inputs)
});